import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";
import {TheCrypt} from "../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {gsap} from "gsap";
import {TheCryptWinConfig} from "../configs/TheCryptWinConfig";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";

export class TheCryptInitialWinPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return TheCrypt.model.isNextRespin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            isLargerWin: boolean = TheCrypt.model.currentWinRatio >= TheCryptWinConfig.WIN_RATIOS.normalWin[3].ratio,
            delayBetweenReelHighlight: number = (isLargerWin ? 0.12 : 0),
            delayBetweenReel: number = (isLargerWin ? 0.2 : 0),
            toggleType:string = TheCryptHelper.getToggleType(),
            soundPlayedOnReel:boolean[] = ArrayHelper.initArrayWithValues(6, ()=>false),
            fullWildOnReel:boolean[] = ArrayHelper.initArrayWithValues(6, ()=>false);

        let explosionSounds:string[] = [],toggleSounds:string[] = [],toggleMSymSounds:string[] = [];
        if(isLargerWin){
            explosionSounds = ArrayHelper.shuffle(TheCryptSoundConfig.WIN_EXPLOSION_MULTI);
        }
        const highlightSounds = ArrayHelper.shuffle(isLargerWin?TheCryptSoundConfig.WIN_HIGHLIGHT_HIGH:TheCryptSoundConfig.WIN_HIGHLIGHT_LOW),
         highlightMSymSounds = ArrayHelper.shuffle(TheCryptSoundConfig.WIN_HIGHLIGHT_M_SYM);
        toggleMSymSounds = highlightMSymSounds;
        toggleSounds = highlightSounds;

        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
            explodeLineTimeLine.timeScale(2);
        }));
        tl.add(() => {}, ( TheCrypt.model.hasXWaysSymbolThisAvalanche && TheCrypt.model.hasNudge.indexOf(true) < 0) ? 0.6 : 0);
        tl.add(TheCrypt.realArea.addDimmer());
        const explodeLineTimeLine: gsap.core.Timeline = gsap.timeline();
        TheCrypt.model.gameData.betWayWins.forEach((betWayWin: IBetWayWinData, l:number) => {
            const winLineTL: gsap.core.Timeline = gsap.timeline(),
                winNumPlayPosition: number[] = TheCrypt.initialWinView.findLastNoWildSymbolPosition(betWayWin);
            betWayWin.reelWinPositions.forEach((reelWin: boolean[], i: number) => {
                reelWin.forEach((winPos: boolean, j: number) => {
                    if (winPos) {
                        const sym:TheCryptSymbol = TheCrypt.realArea.getSymbol([i, j]);
                        if(sym.symName === "FW"){
                            fullWildOnReel[i] = true;
                        }
                        if (i === winNumPlayPosition[0] && j === winNumPlayPosition[1]) {
                            winLineTL.add(() => {
                                TheCrypt.initialWinView.playWinNumbers(betWayWin, false, winNumPlayPosition)
                            }, i * delayBetweenReelHighlight);
                        }
                        winLineTL.add(sym.playInitialWin(toggleType), 0);
                        if (isLargerWin && !soundPlayedOnReel[i]) {
                            explodeLineTimeLine.add(() => {
                                TheCryptSoundManager.playSound(explosionSounds[i]);
                                if(fullWildOnReel[i]){
                                    TheCryptSoundManager.playSound("wildExplosion");
                                }
                            }, i * delayBetweenReel);
                            soundPlayedOnReel[i] = true;
                        }
                        explodeLineTimeLine.add(sym.explode(toggleType), i * delayBetweenReel);
                    }
                });
            });
            tl.add([
                ()=>{
                    if(l === 0){
                        TheCrypt.reelFrame.onWinToggle();
                        TheCrypt.reelBackground.onWinToggle();
                    }
                    TheCryptSoundManager.playSound(betWayWin.symbol[0] === "M"?toggleMSymSounds[l%3]:toggleSounds[l%3]);
                    if(fullWildOnReel.indexOf(true)>-1){
                        TheCryptSoundManager.playSound("wildHighlight");
                    }
                },
                winLineTL
            ]);
        });
        tl.add(TheCrypt.collectors.collect());
        tl.add([
            () => {
                if (!isLargerWin) {
                    TheCryptSoundManager.playSound(TheCryptSoundConfig.WIN_EXPLOSION_SINGLE);
                    if(fullWildOnReel.indexOf(true)>-1){
                        TheCryptSoundManager.playSound("wildExplosion");
                    }
                }
            },
            explodeLineTimeLine
        ]);
        tl.add([
            () => {
                TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
                controller.finish();
            },
            TheCrypt.realArea.removeDimmer()
        ], "-=0.5");

        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
            explodeLineTimeLine.timeScale(1.4);
        }

    }
}